import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { CardTransactionService } from '@/features/cards/services/CardTransactionService';

import { TAppState } from '@/store/reducers/reducers';
import { ICursorElements } from '@/store/types/search.types';

import { ICardTransaction, TCardTransactionsFilters } from '@/features/cards/store/models/card.model';

import { TCardTransactionAction, CardTransactionActionTypes } from '@/store/types/card-transactions.type';
import { TAppError } from '@/store/types/base.state';

export const getCardTransactions = (
  transactionsFilters?: TCardTransactionsFilters,
  cursor: string | null = null,
): ThunkAction<Promise<void>, TAppState, {}, TCardTransactionAction> => {
  const request = (): TCardTransactionAction => ({
    type: CardTransactionActionTypes.GET_CARD_TRANSACTIONS,
  });
  const fail = (error: TAppError): TCardTransactionAction => ({
    type: CardTransactionActionTypes.GET_CARD_TRANSACTIONS_FAIL,
    error,
    documentation: 'https://docs.treezor.com/guide/cards/transactions.html',
  });
  const success = (paginateCardTransactions: ICursorElements<ICardTransaction>): TCardTransactionAction => ({
    type: CardTransactionActionTypes.GET_CARD_TRANSACTIONS_SUCCESS,
    shouldSkipToaster: true,
    paginateCardTransactions,
  });

  return async (dispatch: ThunkDispatch<TAppState, {}, TCardTransactionAction>): Promise<void> => {
    dispatch(request());
    try {
      const paginateCardTransactions = await CardTransactionService.getCardTransactionsById(
        undefined,
        transactionsFilters,
        cursor,
      );
      dispatch(success(paginateCardTransactions));
    } catch (error) {
      dispatch(fail(error));
    }
  };
};
